import { styled } from 'styled-components'

export const Root = styled.div`
  display: flex;
  gap: 4px;
`

export const Button = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`

export const CurrentDate = styled.div`
  font-weight: 500;
`
